var InputBase = require('../base');

var Spinner = InputBase.extend( {
    create: function( inputOptions, $container ) {
        var self = this;

        inputOptions.stop = function() {
            if ( self.model.validationEvent === 'spin' ) {
                self.check();
            }
            self.trig( 'Spin' );
        };
        if (self.model.inputRule) {
            if (self.model.inputRule.max || self.model.inputRule.max === 0) {
                inputOptions.max = self.model.inputRule.max;
            }
            if (self.model.inputRule.min || self.model.inputRule.min === 0) {
                inputOptions.min = self.model.inputRule.min;
            }
        }
        // inputOptions.change = function() {
        //     if ( model.validationEvent === 'change' ) {
        //         self.check();
        //     }
        //     self.trig( 'change' );
        // };

        // inputOptions.page = 5;
        var $inp = $( '<input type="text">' )
                .appendTo( $container )
                .on( 'focus', function() {
                    self.trig( 'Focus');
                } )
                .on( 'change', function() {
                    if ( self.model.validationEvent === 'change' ) {
                        self.check();
                    }
                    self.trig( 'Change' );
                } )
                .on( 'blur', function() {
                    if ( self.model.validationEvent === 'blur' ) {
                        self.check();
                    }
                    self.trig( 'Blur' );
                } )
                .on( 'keyup', function() {
                    self.trig( 'Keyup' );
                } )
                .spinner( inputOptions );
        self.$inp = $inp;
        return $inp;
    },
    /*
    getValue: function() {
    },
    setValue: function( value ) {
    },*/
    bindCheckEvent: function( eventName ) {
        
    }
} );

module.exports = Spinner;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/spinner/index.js
// module id = 17
// module chunks = 0